import { render, staticRenderFns } from "./CompetitionRegistrationInput_phone.vue?vue&type=template&id=1b067252&scoped=true"
import script from "./CompetitionRegistrationInput_phone.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistrationInput_phone.vue?vue&type=script&lang=js"
import style1 from "./CompetitionRegistrationInput_phone.vue?vue&type=style&index=1&id=1b067252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b067252",
  null
  
)

export default component.exports